export const EnvironmentBanner = () => {
    const env = import.meta.env.VITE_ENV;

    // Non mostrare la barra in production
    if (env === "production") {
        return null;
    }

    // Determina il colore in base all'ambiente
    const getBackgroundColor = () => {
        if (env === "staging") {
            return "bg-orange-500";
        }
        // Default per development o altri ambienti non-production
        return "bg-purple-500";
    };

    // Determina il testo da mostrare
    const getEnvironmentText = () => {
        if (env === "staging") {
            return "Staging Environment";
        }
        return "Development Environment";
    };

    return (
        <div
            className={`fixed top-0 left-0 right-0 w-full h-7 ${getBackgroundColor()} text-white text-center font-bold flex items-center justify-center z-50`}
            role="banner"
            aria-label={`Environment: ${getEnvironmentText()}`}
        >
            {getEnvironmentText()}
        </div>
    );
};

